import AccountSummaryPage from "components/pages/AccountSummaryPage";

/**
 * @name CaptureAccountSummaryDefault
 * @returns {React.Component}
 * @description 
 */
export default function CaptureAccountSummaryDefault(props) {
    return <AccountSummaryPage/>;
}